import React from 'react'
import { Marked } from 'marked'
import { markedHighlight } from 'marked-highlight'
import hljs from 'highlight.js'
// @ts-ignore
import hlsjLookML from 'highlightjs-lookml'
import { MessageContent } from '../../../../components/graphql'

hljs.registerLanguage('lookml', hlsjLookML)

const marked = new Marked(
  markedHighlight({
    langPrefix: 'hljs border rounded shadow syntax-highlighter language-',
    highlight(code, lang) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext'
      return hljs.highlight(code, { language }).value
    },
  })
)
const processText = (text: string) => {
  if (!text) {
    return text
  }
  const modifiedText = marked.parse(text, {
    gfm: true,
    breaks: true,
  })
  return modifiedText
}

const TextContent = ({ content }: { content: MessageContent }) => {
  if (!content || !content.value) {
    return null
  }
  const textValue = content.value
  return (
    <div
      className="prose text-sm max-w-none my-5 mx-2 text-wrap break-words"
      dangerouslySetInnerHTML={{ __html: processText(textValue) }}
    ></div>
  )
}

export default TextContent
